import React, { useCallback, useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"

import PriceService from "src/services/price-service"
import DataGridTable from "src/v2/components/Table/data-grid-table"
import { dispatchSnackbar } from "src/v2/components/SnackBar/snackbar-bus"

import { columnsInadimplentesLGD } from "./tabela-inadimplentes-lgd-constants"


const TabelaInadimplentesLGD = ({
    date,
    loading,
    setLoading,
    onFilterQueryChange,
}) => {
    const priceService = useMemo(() => new PriceService(), [])

    const [rows, setRows] = useState([])
    const [filterModel, setFilterModel] = useState({ items: [] })
    const [resetKey, setResetKey] = useState(0)

    const filterQuery = useMemo(
        () =>
            filterModel.items.filter(
                (item) => item.field && item.value !== undefined && item.value !== "").map(
                    (item) => `${encodeURIComponent(item.field)}=${encodeURIComponent(item.value)}`).join("&"),
        [filterModel]
    )

    useEffect(() => {
        onFilterQueryChange(filterQuery)
    }, [filterQuery, onFilterQueryChange])

    const loadInadimplentes = useCallback(
        async (filters = "") => {
            if (!date) return

            setLoading(true)

            try {
                const response =
                    await priceService.getInadimplentesLGD(date, filters)

                const body = response.body || {}

                const results = body.data || []

                setRows(
                    results.map(
                        (item, index) => ({
                            ...item,
                            id:
                                item.ID ||
                                `${item.CETIP ||
                                "item"
                                }-${index}`,
                        })
                    )
                )

            } catch (error) {
                setRows([])

                dispatchSnackbar("Não foi possível carregar os inadimplentes LGD, tente novamente", "error")
            } finally {
                setLoading(false)
            }
        },
        [date, priceService, setLoading,]
    )

    useEffect(() => {
        setResetKey((value) => value + 1)

        loadInadimplentes(filterQuery)
    }, [date, filterQuery, loadInadimplentes,
    ])


    const handleFilterChange = (model) => {
        setFilterModel(model)

        setResetKey((value) => value + 1)
    }

    return (
        <DataGridTable
            rows={rows}
            rowPadding={2}
            columns={
                columnsInadimplentesLGD
            }
            loading={loading}
            contained
            autoRowHeight
            disableRowSelectionOnClick
            resetKey={`${resetKey}`}
            filterModel={filterModel}
            onFilterModelChange={
                handleFilterChange
            }
        />
    )
}


TabelaInadimplentesLGD.propTypes = {
    date: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
    onFilterQueryChange: PropTypes.func.isRequired,
}


export default TabelaInadimplentesLGD